_ = require("lodash")


getDefaultScoreValues = (hole_number) ->
  hole_number: hole_number
  shot_cnt: undefined
  putt_cnt: undefined
  fairway: undefined
  tee_off_club: undefined
  sand_shot: undefined
  water_hazard: undefined
  ob: undefined
  is_par_on: undefined

ScoreCardParser = ->
  calculateTotal = (scores, isOut) ->
    _.chain scores
      .filter (s) ->
        return s.hole_number >= 10 unless isOut
        return s.hole_number < 10 if isOut
      .map (s) ->
        shot_cnt: s.shot_cnt || 0
        putt_cnt: s.putt_cnt || 0
        water_hazard: s.water_hazard || 0
        sand_shot: s.sand_shot || 0
        ob: s.ob || 0
      .reduce (sum, s) ->
        sum.total_shot += s.shot_cnt
        sum.total_putt += s.putt_cnt
        sum.total_water_hazard += s.water_hazard
        sum.total_sand_shot += s.sand_shot
        sum.total_ob += s.ob
        sum
      , {total_shot: 0, total_putt: 0, total_water_hazard: 0, total_sand_shot: 0, total_ob: 0}
      .value()

  fillGappedScoresForPlayer = (holeSize) -> (player) ->
    #fill the missing hole
    _.times holeSize, (i) ->
      unless (_.find player.scores, (s) -> s.hole_number is i + 1)
        player.scores.push getDefaultScoreValues(i + 1)
    #ignore zero shot_cnt and sortBy hole_number
    player.scores = _.chain player.scores
                      .map (s) ->
                        return getDefaultScoreValues(s.hole_number) if s.shot_cnt is 0
                        return s
                      .sortBy (s) -> s.hole_number
                      .value()

  fillGappedScoresExtraForPlayer = (holeSize, extraIndex) -> (player) ->
    # #fill the missing hole
    if player.scores_extra.length < 9
      _.times holeSize, (i) ->
        unless (_.find player.scores_extra, (s) -> s.hole_number is i + extraIndex)
          player.scores_extra.push getDefaultScoreValues(i + extraIndex)
    player.scores_extra = _.chain player.scores_extra
                      .map (s) ->
                        return getDefaultScoreValues(s.hole_number) if s.shot_cnt is 0
                        if s.shot_cnt or s.putt_cnt
                          if extraIndex == 1 and s.hole_number > 9
                            s.hole_number = s.hole_number - 9
                          else if extraIndex == 10 and s.hole_number <= 9
                            s.hole_number = s.hole_number + 9
                        return s
                      .sortBy (s) -> s.hole_number
                      .value()

  fillGappedScores = (scorecard) ->
    holeSize = scorecard.holes.length
    _.forEach scorecard.players, fillGappedScoresForPlayer(holeSize)
    extraIndex = if scorecard.holes_extra and scorecard.holes_extra[0].hole_number > 9 then 10 else 1
    if scorecard.holes_extra
      _.forEach scorecard.players, fillGappedScoresExtraForPlayer(scorecard.holes_extra.length, extraIndex)
    scorecard

  parseScoreCardBoard = (roundInfo, isOut) ->
    filledRoundInfo = fillGappedScores _.cloneDeep(roundInfo)
    scoreCardBoard =
      holes: if isOut then _.take(filledRoundInfo.holes, 9) else _.takeRight(filledRoundInfo.holes, 9)
      players:
        if filledRoundInfo.players
          _.map filledRoundInfo.players, (p) ->
            id: p.id
            name: p.name
            scores: if isOut then _.take(p.scores, 9) else _.takeRight(p.scores, 9)
            isOwner: p is filledRoundInfo.players[0]
        else
          null

    scoreCardBoard

  parseScoreCardExtraBoard: (roundInfo) ->
    filledRoundInfo = fillGappedScores _.cloneDeep(roundInfo)
    scoreCardBoard =
      holes: _.take(filledRoundInfo.holes_extra, 9)
      players:
        if filledRoundInfo.players
          _.map filledRoundInfo.players, (p) ->
            id: p.id
            name: p.name
            scores: _.take(p.scores_extra, 9)
            isOwner: p is filledRoundInfo.players[0]
        else
          null

    scoreCardBoard

  parseInViewModel: (roundInfo) ->
    parseScoreCardBoard roundInfo, false

  parseOutViewModel: (roundInfo) ->
    parseScoreCardBoard roundInfo, true

  parseTotalViewModel: (roundInfo, is18Holes) ->
    totalOut = calculateTotal(roundInfo.players[0].scores, true)
    totalIn = calculateTotal(roundInfo.players[0].scores, false) if is18Holes

    total =
      owner_player: _.pick roundInfo.players[0], ["player_hdcp"]
      in: totalIn || {}
      out: totalOut

    # gross = in + out
    total.gross = _.clone(total.out)
    
    if totalIn
      _.mergeWith(total.gross, total.in, (e1, e2) ->
        if _.isNumber(e1) and _.isNumber(e2)
          e1 + e2
        else
          e2
      )

    total

module.exports = ScoreCardParser




// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/score-card/score-card-parser.coffee